<script>
import _ from 'lodash'
import RecordTransferService from '@/request/record/transfer'
import RecordService from '@/request/record/record'
import OrgService from '@/request/user/org'
export default {
  name: 'RecordTransferEdit',
  components: {},
  props: {
    rid: Number,
    bedid: String,
    forg: Number
  },
  data () {
    return {
      transfer: {},
      orgSelection: [],
      hospital: {},
      org: {},
      saving: false
    }
  },
  created () {
    this.init()
  },
  computed: {},
  watch: {
    'transfer.type': function (val) {
      if (val) {
        this.$set(this.transfer, 'trecord', null)
      } else {
        this.$set(this.transfer, 'trecord', this.rid)
      }
    },
    rid () {
      this.init()
    },
    forg () {
      this.init()
    }
  },
  methods: {
    init () {
      if (!this.rid || !this.forg) {
        this.$emit('saveDone', null)
        return
      }
      this.loadOrg()
      this.transfer = _.clone({
        frecord: this.rid,
        trecord: this.rid,
        torg: null,
        tbedid: this.bedid,
        type: 0
      })
      this.listOrgs()
    },
    loadOrg () {
      if (!this.forg) {
        return
      }
      OrgService.loadOrg({
        descendantId: this.forg,
        parentTypeSn: 'lx0001001'
      }).then(data => {
        if (data.result) {
          this.hospital = _.cloneDeep(data.result)
        }
      })
      OrgService.loadOrg({
        id: this.forg
      }).then(data => {
        if (data.result) {
          this.org = _.cloneDeep(data.result)
        }
      })
    },
    checkBedid () {
      let self = this
      return new Promise((resolve, reject) => {
        if (_.isEmpty(self.hospital)) {
          resolve()
          return
        }
        if (!self.transfer.tbedid) {
          resolve()
          return
        }
        if (self.transfer.tbedid === self.bedid) {
          resolve()
          return
        }
        RecordService.count({
          hospitalized: 1,
          status: '1,2,3,4,5',
          hids: self.hospital.id,
          bedid: self.transfer.tbedid
        }).then(res => {
          let data = res.result
          if (data) {
            self.$confirm('床位号：' + self.transfer.tbedid + '已经被其它患者占用！如果继续保存，原病历将自动出院！', '提示', {
              confirmButtonText: '强制出院',
              cancelButtonText: '更改床号',
              type: 'warning'
            }).then(() => {
              self.$message({
                message: '保存后，原[' + self.transfer.tbedid + ']床的病历出院',
                type: 'warning'
              })
              resolve()
            }).catch(() => {
              self.transfer.tbedid = null
              reject(false)
            })
          } else {
            resolve()
          }
        }).catch(() => {
          resolve()
        })
      })
    },
    listOrgs () {
      this.orgSelection = []
      RecordTransferService.listOrg({oid: this.forg}).then(res => {
        let data = res.result || []
        _.remove(data, org => {
          return org.id === this.forg
        })
        this.orgSelection = _.clone(data)
      })
    },
    save () {
      let _transfer = _.cloneDeep(this.transfer)
      delete _transfer.type
      let pcheck = this.checkBedid()
      pcheck.then(() => {
        this.saving = true
        RecordTransferService.save(_transfer).then(res => {
          this.$emit('saveDone', res.result || {})
        }).catch(error => {
          this.$message.error(error || '转科失败')
        }).finally(() => {
          this.saving = false
        })
      })
    }
  }
}
</script>

<template>
  <el-form ref="form" :model="transfer" :disabled="saving" @keyup.enter.native="save" label-position="right" label-width="80px">
    <el-form-item label="将病历">
      <el-row :gutter="0">
        <el-col :span="6">
          <el-form-item prop="type">
            <el-select v-model="transfer.type" placeholder="请选择方式" style="width: 100%;">
              <el-option :key="0" label="移动" :value="0"></el-option>
              <el-option :key="1" label="复制" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col style="text-align: center;" :span="2">到</el-col>
        <el-col :span="16">
          <el-form-item prop="torg">
            <el-select v-model="transfer.torg" clearable placeholder="请选择科室" style="width: 100%;">
              <el-option
                v-for="org in orgSelection"
                :key="org.id"
                :label="org.name"
                :value="org.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item label="床位号" prop="tbedid">
      <el-input v-model="transfer.tbedid" placeholder="请输入住院床号"></el-input>
    </el-form-item>
    <el-form-item v-if="org.id">
      {{org.name}}将<span v-if="transfer.type === 0">不</span>保留原病历
    </el-form-item>
  </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
